import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { ThemeProvider } from "@material-ui/styles";
import theme from "../../../../Themes/defaultTheme";
import { getSelectableFirms } from "../../../../../Utils/apis/professionalContactsApi";
import A_Select from "../../../Atoms/Inputs/Selects/A_Select";

const M_FirmPicker = ({
  id,
  label,
  loanId,
  role,
  value,
  onChange,
  required,
  clearable = false,
  error,
  helperText,
  disabled,
  fullWidth,
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadError, setLoadError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    if (!loanId || !role) return undefined;
    setLoading(true);
    setLoadError(null);
    getSelectableFirms(loanId, role)
      .then((firms) => {
        if (!cancelled) setOptions(Array.isArray(firms) ? firms : []);
      })
      .catch((err) => {
        if (!cancelled) setLoadError(err);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [loanId, role]);

  const selectOptions = [
    ...(clearable ? [{ value: "", label: "None" }] : []),
    ...options.map((firm) => ({
      value: firm.id,
      label: firm.name,
    })),
  ];

  const handleSelectChange = (selectedOption) => {
    const val = selectedOption?.value || "";
    const firm = options.find((f) => f.id === val) || null;
    onChange(firm);
  };

  return (
    <ThemeProvider theme={theme}>
      <A_Select
        id={id}
        label={label}
        value={value || ""}
        defaultValue={value || ""}
        options={selectOptions}
        onChange={handleSelectChange}
        searchable={false}
        error={Boolean(error) || Boolean(loadError)}
        helperText={
          loadError ? "Couldn't load firms for this role" : helperText
        }
        helperTextId={id ? `${id}-helper-text` : undefined}
        disabled={disabled || loading}
        required={required}
        clearable={clearable}
        fullWidth={fullWidth}
        variant="outlined"
        InputLabelProps={{ shrink: true, htmlFor: id }}
        style={{ width: "100%", margin: 0 }}
      />
    </ThemeProvider>
  );
};

M_FirmPicker.defaultProps = {
  fullWidth: true,
  required: false,
  clearable: false,
  disabled: false,
  error: false,
  helperText: "",
};

M_FirmPicker.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  loanId: PropTypes.string,
  role: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  clearable: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
};

export default M_FirmPicker;
